import React from 'react';
import { XIcon } from 'lucide-react';
import { Button } from '@/Components/shadcn/button';
import { ImageCropContextProps } from './ImageCropContext';
import { ImageCropStrings } from './ImageCropUtils';

export interface ImageCropDialogHeaderProps
    extends Pick<ImageCropStrings, 'dialogHeaderText'>, Pick<ImageCropContextProps, 'processing'> {
    onClick: () => void;
}

export const ImageCropDialogHeader = ({
    onClick,
    processing,
    dialogHeaderText,
}: ImageCropDialogHeaderProps): React.JSX.Element => {
    return (
        <div className="flex flex-row items-center justify-between">
            <span className="text-lg font-bold">{dialogHeaderText}</span>
            <Button
                data-cy="ImageCropDialogCloseButton"
                variant="ghost"
                size="icon-sm"
                disabled={processing}
                onClick={onClick}
            >
                <XIcon />
            </Button>
        </div>
    );
};
